import React, { FC } from 'react';
import { TransactionsDateColumnApproved } from './TransactionsDateColumnApproved';
import { TransactionsDateColumnUnapproved } from './TransactionsDateColumnUnapproved';
import './TransactionsDateColumn.scss';
import { FormattedDate } from '../../../components/table/FormattedDate';
import { TransactionsFilterProperties } from '../filter/TransactionsFilterProperties';

export const TransactionsDateColumn: FC<TransactionsFilterProperties> = ({
  startedAt,
  approvedAt,
  approvedBy,
  isApproved,
}) => {
  if (startedAt) {
    return (
      <div className="TransactionsDateColumn">
        {isApproved ? (
          <TransactionsDateColumnApproved approvedAt={approvedAt} approvedBy={approvedBy} />
        ) : (
          <TransactionsDateColumnUnapproved />
        )}

        <FormattedDate date={startedAt} />
      </div>
    );
  }

  return <>&ndash;</>;
};
